import { publicRoutes } from "./public";
import { privateRoutes } from "./private";
import { fallbackRoutes } from "./fallback";
import { createLazyRouterWithRetry } from "react-router-lazy-retry";

const routes = [...publicRoutes, ...privateRoutes, ...fallbackRoutes];
export const router = createLazyRouterWithRetry('browser', routes, {});